<template>
  <Card>
    <Flex justify-between items-center gap-3>
      <FlexCol justify-center gap-1 class="grow">
        <h1 class="font-semibold text-2xl text-primary-700" :class="{ 'border-b pb-1': breadcrumb }">
          <IconSolid :icon="props.icon" class="mr-2 text-4xl" v-if="props.icon" />
          <span class="font-montserrat-700">{{ props.title }}</span>
        </h1>
        <TheBreadcrumb v-if="breadcrumb" />
      </FlexCol>
      <Flex justify-end gap-3 items-center>
        <slot></slot>
      </Flex>
    </Flex>
  </Card>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: String,
  icon: String,
  breadcrumb: {
    type: Boolean,
    default: false,
  },
})
</script>
